module.exports = __webpack_public_path__ + "img/account-icon-dark.b3ffb7bd.svg";